/*
const myPath = new EllipseTextPath({
  x: 50,
  y: 50,
  fill: 'black',
  fontSize: 24,
  fontFamily: 'Arial',
  text: 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
  radiusX: 200,
  radiusY: 100,
});
console.log("myPath", myPath);
layer.add(myPath);
layer.draw();
*/
class EllipseTextPath extends BaseTextPath {
  constructor(config) {
    super(config);

    this.className = 'EllipseTextPath';
    this.attrs.type = "ellipsetextpath";


    this.radiusX(config?.radiusX ?? 200);
    this.radiusY(config?.radiusY ?? 100);
  }


  static getAttrNames() { return ['radiusX', 'radiusY']; }
  static getDefaultAttrs() { return { radiusX: 200, radiusY: 100 }; }


  radiusX(v) {
    if (v === undefined) return this.attrs.radiusX ?? 0;
    this.attrs.radiusX = v;
    this.updatePath();
    return this;
  }


  radiusY(v) {
    if (v === undefined) return this.attrs.radiusY ?? 0;
    this.attrs.radiusY = v;
    this.updatePath();
    return this;
  }


  updatePath() {
    console.log("updatePath ellipse", this.radiusX(), this.radiusY());
    this.setData(this.generateSvgPath(200, 200, this.radiusX(), this.radiusY(), 0));
  }


  generateSvgPath(cx, cy, rx, ry, rotation = 0) {
    // cx, cy: center coordinates of the ellipse
    // rx, ry: radii of the ellipse along x and y axes
    // rotation: rotation of the ellipse in degrees (optional, defaults to 0)

    // Convert rotation to radians for trigonometric functions
    const rotationRad = (rotation * Math.PI) / 180;

    // Calculate the start and end points for the two arcs
    // For a full ellipse, the start and end points of the first arc
    // are the same as the end and start points of the second arc.
    // We'll start at the rightmost point of the ellipse.
    const startX = cx + rx * Math.cos(rotationRad);
    const startY = cy + rx * Math.sin(rotationRad);

    // The point directly opposite the start point, to form the first arc.
    const midX = cx - rx * Math.cos(rotationRad);
    const midY = cy - rx * Math.sin(rotationRad);

    // The large-arc-flag (1 for angles > 180 degrees)
    // The sweep-flag (1 for positive angle direction)
    const largeArcFlag = 1;
    const sweepFlag = 1;

    // Construct the path data string
    // M: Move to the starting point
    // A: Arc command (rx ry x-axis-rotation large-arc-flag sweep-flag x y)
    const pathData = `M ${startX} ${startY}
                      A ${rx} ${ry} ${rotation} ${largeArcFlag} ${sweepFlag} ${midX} ${midY}
                      A ${rx} ${ry} ${rotation} ${largeArcFlag} ${sweepFlag} ${startX} ${startY}`;

    return pathData;
  }
}


